<template>
  <div class="admin-inbox" @click="openInbox">
    <a-tooltip title="站内信">
      <a-badge :count="unreadCount" :overflow-count="99">
        <MailOutlined style="cursor: pointer; font-size: 16px;" />
      </a-badge>
    </a-tooltip>
  </div>

  <!-- 站内信弹窗 - 使用Teleport确保渲染在body下 -->
  <Teleport to="body">
    <MessageModal />
  </Teleport>
</template>

<script setup>
import { onMounted, onUnmounted, getCurrentInstance, computed } from 'vue'
import { storeToRefs } from 'pinia'
import { MailOutlined } from '@ant-design/icons-vue'
import useMessageStore from '@/stores/message'
import MessageModal from '@/components/MessageModal.vue'

const { proxy } = getCurrentInstance()
const messageStore = useMessageStore()
const { messages } = storeToRefs(messageStore)

// 未读数量
const unreadCount = computed(() => messages.value.length)

// 获取用户SteamID
const getSteamId = () => {
  return proxy.$user()?.SteamID || ''
}

// 打开站内信
const openInbox = () => {
  console.log('点击站内信图标, visible:', messageStore.visible);
  messageStore.showModal()
  console.log('调用showModal后, visible:', messageStore.visible);
}

// 组件挂载时开始轮询
onMounted(() => {
  const steamid = getSteamId()
  console.log('admin-inbox mounted, steamid:', steamid)
  if (steamid) {
    messageStore.startPolling(steamid)
  }
})

// 组件卸载时停止轮询
onUnmounted(() => {
  messageStore.stopPolling()
})
</script>

<style scoped lang="scss">
.admin-inbox {
  @include flex-center;
  justify-content: center;
  cursor: pointer;

  width: 30px;
  height: 30px;

  margin-right: 15px;
  padding: 5px;
  border-radius: 50%;

  color: $text-color-3;

  border: 1px solid $border;

  &:hover {
    border-color: $primary-color;
    color: $primary-color;
  }
}
</style>
